<div class="chat-content" *ngIf="activeConversation">
  <div class="scroll-holder message-window" *ngIf="channelExists && !isLoadingMessages">
    <div
      class="d-flex align-items-center justify-content-center pe-0 mb-3 chat-content-header ps-3 w-100"
      *ngIf="titleConfiguration"
    >
      <button class="btn back-arrow px-2 me-3" (click)="onBackBtnClick()" data-test-id="back-arrow-btn">
        <svg-icon src="assets/icons/icon-arrow-left.svg" class="icon-arrow-left"></svg-icon>
      </button>
      <div class="w-100 d-flex justify-content-center align-items-center">
        <h2 data-test-id="conversation-title" title="{{ titleConfiguration.text }}">
          {{ titleConfiguration.text }}
        </h2>

        <span
          data-test-id="edit-title-button"
          *ngIf="activeConversation.participatingUsers.length !== 2"
          class="edit-btn bottom-right ps-2 pe-16"
          role="button"
          (click)="onEditConversationTitle()"
          ><svg-icon src="assets/icons/icon-pencil.svg" class="icon-pencil"> </svg-icon>
        </span>
      </div>

      <div
        ngbDropdown
        class="text-primary w-100p position"
        placement="bottom-right"
        *ngIf="activeConversation.participatingUsers.length !== 2"
      >
        <button
          ngbDropdownToggle
          data-test-id="describe-title-button"
          type="button"
          class="btn btn-link text-primary hide-caret"
        >
          {{ activeConversation.participatingUsers.length }} {{ 'MAP_PEOPLE_HINT' | translate }}
        </button>
        <div ngbDropdownMenu aria-labelledby="dropdownMenu" autoClose="true" class="w-250p">
          <ng-container *ngFor="let participatingUsers of activeConversation.participatingUsers; index as i">
            <div ngbDropdownItem>
              <app-profile-link
                [dataTestId]="'messages-user-' + i"
                [cssStyles]="'dotted-text pe-0'"
                [status]="participatingUsers.userStatus"
                [userId]="participatingUsers.userId"
                [text]="participatingUsers.userName"
              ></app-profile-link>
            </div>
          </ng-container>
        </div>
      </div>

      <div data-test-id="block-user-wrapper" class="position" *ngIf="needsDropdownMenu">
        <div ngbDropdown>
          <button
            id="block-user-menu"
            ngbDropdownToggle
            type="button"
            class="btn btn-link hide-caret block-user-menu"
            data-test-id="block-user-menu"
          >
            ...
          </button>
          <div ngbDropdownMenu aria-labelledby="block-user-menu">
            <button *ngIf="permissions.canBlockChat" data-test-id="block-user" ngbDropdownItem (click)="onBlockUser()">
              {{ 'CHAT_BTN_BLOCK_USER' | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <div
      #chatContent
      infiniteScroll
      [infiniteScrollUpDistance]="0"
      [infiniteScrollThrottle]="50"
      (scrolledUp)="onScrolledUp()"
      [scrollWindow]="false"
      [alwaysCallback]="true"
      class="scroll-able mb-3"
    >
      <div class="d-flex align-items-end flex-column">
        <div class="w-100" *ngFor="let message of messages; index as i">
          <app-message-block
            [message]="message"
            [currentUserId]="currentUserId"
            [participants]="activeConversation.participatingUsers"
            [index]="i"
            (editMessage)="onEditMessageStarted($event)"
            (removeMessage)="onRemoveMessage($event)"
          ></app-message-block>
        </div>
        <div
          class="py-4 d-flex justify-content-center w-100"
          data-test-id="user-deleted-hint"
          *ngIf="displayAccountStatusHint"
        >
          <h3>
            {{ accountStatusHint | translate }}
          </h3>
        </div>
        <div class="py-4" *ngIf="!isLoadingMessages && messages.length === 0">
          <h1 class="text-muted">
            {{ 'CHAT_NO_MESSAGES_HINT' | translate }}
          </h1>
        </div>
        <div *ngIf="isLoadingMessages">
          <div class="spinner-border text-primary" role="status">
            <span class="sr-only">
              {{ 'LOADING_HINT' | translate }}
            </span>
          </div>
        </div>
      </div>
    </div>
    <app-message-form-field
      data-test-id="chat-form"
      [messageForEdit]="messageForEdit"
      [memberTypingName]="memberTypingName"
      [isReadOnly]="!permissions.canSendMessages"
      [placeholderPhrases]="placeholderPhrases"
      [counterVisibility]="true"
      (userTyping)="onUserTyping()"
      (sendTextMessage)="onSendTextMessage($event)"
      (editMessageFinished)="onEditMessageFinished($event)"
      (enteringMessageAborted)="onEnteringMessageAborted()"
      (dirtyForm)="setFormStatus($event)"
    ></app-message-form-field>
  </div>
  <div *ngIf="isLoadingMessages && channelExists">
    <div class="spinner-grow text-primary" role="status">
      <span class="sr-only">
        {{ 'LOADING_HINT' | translate }}
      </span>
    </div>
  </div>
  <div class="heading-holder">
    <h2 *ngIf="!channelExists && !isLoadingMessages">There is no such channel</h2>
  </div>
</div>
